import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpExpressionDefinitionOutputFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpExpressionDefinitionOutput
 */

export class ExpExpressionDefinitionOutputFactory {}
_ExpExpressionDefinitionOutputFactory = ExpExpressionDefinitionOutputFactory;
_defineProperty(ExpExpressionDefinitionOutputFactory, "FromJSON", function (json) {
  return _ExpExpressionDefinitionOutputFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpExpressionDefinitionOutputFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'valueTypeID': json['valueTypeID'],
    'categoryID': json['categoryID'],
    'multiple': json['multiple']
  };
});
_defineProperty(ExpExpressionDefinitionOutputFactory, "ToJSON", function (value) {
  return _ExpExpressionDefinitionOutputFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpExpressionDefinitionOutputFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'valueTypeID': value.valueTypeID,
    'categoryID': value.categoryID,
    'multiple': value.multiple
  };
});
//# sourceMappingURL=ExpExpressionDefinitionOutput.js.map
